import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/index.vue";
import News from "../views/news.vue";
import Notices from "../views/notices.vue";
import Policy from "../views/policy.vue";
import NewsDetails from "../views/newsDetails.vue";
import CourseLearning from "@/views/courseLearning.vue";
import MyCourses from "@/views/myCourses.vue";
import CoursesDetails from "@/views/coursesDetails.vue";
import Usercenter from "@/views/usercenter.vue";
import CourseDes from "@/views/courseDes.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: Index,
    meta: { title: "山东省科教人才发展继续教育平台" },
  },
  {
    path: "/news",
    name: "News",
    component: News,
  },
  {
    path: "/policy",
    name: "Policy",
    component: Policy,
  },
  {
    path: "/notices",
    name: "Notices",
    component: Notices,
  },
  {
    path: "/newsDetails",
    name: "NewsDetails",
    component: NewsDetails,
  },
  {
    path: "/courseLearning",
    name: "CourseLearning",
    component: CourseLearning,
  },
  {
    path: "/myCourses",
    name: "MyCourses",
    component: MyCourses,
  },
  {
    path: "/coursesDetails",
    name: "CoursesDetails",
    component: CoursesDetails,
  },
  {
    path: "/courseDes",
    name: "CourseDes",
    component: CourseDes,
  },
  {
    path: "/usercenter",
    name: "Usercenter",
    component: Usercenter,
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
});

export default router;
